const tableTitleEquip = {
  title: 'Tipos de Equipos',
  placeholder: 'Buscar'
}

export default tableTitleEquip;
